import React from 'react';

import Form from 'antd/lib/form';
import Input from 'antd/lib/input';

import { getRequiredRule } from 'features/signup/signup-utils';

const LABEL = 'Company';
const NAME = 'company';
const VALIDATION_RULES = [getRequiredRule(LABEL)];

const Company = (): JSX.Element => (
  <Form.Item label={LABEL} labelAlign="left" name={NAME} required rules={VALIDATION_RULES}>
    <Input name={NAME} />
  </Form.Item>
);

export default Company;
